export const CarouselData = [
    {
        image: 'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_773947222_97e3ce6e-89fa-4a0f-a5d5-d0d373ae995e_1512x.jpg?v=1660340662',
        title: 'World Of Valentino',
        desc: 'Shop Handbags, Shoes, Apparel, Accessories &amp; More',
        link: 'SHOP VALENTINO'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_1207523875_1512x.jpg?v=1660338294',
        title: 'GUCCI',
        desc: 'THIS ICONIC BRAND IS REPRESENTED WITH GREAT DESIGN CONTEMPORARY LIFESTYLE',
        link: 'SHOP NOW'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_2056290722_1512x.jpg?v=1660337209',
        title: 'Bottega Veneta',
        desc: 'UNSURPASSED CRAFTSMANSHIP THE SIGNATURE WOVEN LEATHER',
        link: 'SHOP NOW'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_324325775_1_1512x.jpg?v=1660337720',
        title: 'PRADA',
        desc: 'AN ITALIAN FASHION HOUSE MADE WITH CLASSIC ECCENTRIC STYLE',
        link: 'SHOP NOW'
    },
    {
        image:'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_390723769_4_7_1512x.jpg?v=1660348351',
        title:'LUXE HANDBAGS',
        desc:"Styles from Gucci, Prada, Saint Laurent, Bottega Veneta, Fendi",
        link:"SHOP HANDBAGS",
    },
    {
        image:'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_1464509732_1_e307f109-5b85-417e-93c7-9420d8804949_1512x.jpg?v=1660343364',
        title:'Fendi',
        desc:"A TOP FASHION BRAND THAT CULTIVATES THE MOST ELEVATED DESIGN OF STYLES",
        link:"SHOP NOW",
    },
    {
        image:'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_442324294_1512x.jpg?v=1660338965',
        title:'DESIGNER SHOES',
        desc:"Step Into The New Season With New Designer Shoes",
        link:"SHOP WOMEN",
    },
    {
        image:'https://cdn.shopify.com/s/files/1/0248/3473/6191/files/shutterstock_1161591199_1512x.jpg?v=1660339761',
        title:'ICONIC SUNGLASSES',
        desc:"Featuring Dior, Tom Ford, Fendi",
        link:"SHOP WOMEN'S GLASSES",
    }
]